import { PayloadAction, createSlice } from '@reduxjs/toolkit'

import { AddressCandidate, AuthState, NovuSubscriberInfo, ProductLicense } from '../types'
import { Organization, OrganizationSitesResponse } from '../types/organization.types'
import { Site } from '../types/site.types'
import { UserDetails } from '../user/domain/user.types'

const initialState: AuthState = {
  isAuthenticated: false,
  isReady: false,
  bootstrapError: false,
  sessionExpired: false,
  name: undefined,
  accessToken: undefined,
  novuSubscriberInfo: undefined,
  productLicenses: [],
  parentOrganization: undefined,
  sites: [],
  currentSite: undefined,
  userDetails: undefined,
  organization: undefined,
  addressCandidate: [],
  workingAddress: undefined,
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthenticated: (state, action: PayloadAction<boolean>) => {
      state.isAuthenticated = action.payload
    },
    setReady: (state, action: PayloadAction<boolean>) => {
      state.isReady = action.payload
    },
    setBootstrapError: (state, action: PayloadAction<boolean>) => {
      state.bootstrapError = action.payload
    },
    setSessionExpired: (state, action: PayloadAction<boolean>) => {
      state.sessionExpired = action.payload
    },
    setName: (state, action: PayloadAction<string | undefined>) => {
      state.name = action.payload
    },
    setAccessToken: (state, action: PayloadAction<string | undefined>) => {
      state.accessToken = action.payload
    },
    setNovuSubscriberInfo: (state, action: PayloadAction<NovuSubscriberInfo | undefined>) => {
      state.novuSubscriberInfo = action.payload
    },
    setProductLicenses: (state, action: PayloadAction<ProductLicense[] | undefined>) => {
      state.productLicenses = action.payload
    },
    setUserDetails: (state, action: PayloadAction<UserDetails | undefined>) => {
      state.userDetails = action.payload
    },
    setOrganization: (state, action: PayloadAction<Organization | undefined>) => {
      state.organization = action.payload
    },
    setParentOrganization: (state, action: PayloadAction<Organization | undefined>) => {
      state.parentOrganization = action.payload
    },
    setSites: (state, action: PayloadAction<OrganizationSitesResponse[]>) => {
      state.sites = action.payload
    },
    setCurrentSite: (state, action: PayloadAction<Site | undefined>) => {
      state.currentSite = action.payload
    },
    setAddressCandidate: (state, action: PayloadAction<AddressCandidate[] | undefined>) => {
      state.addressCandidate = action.payload
    },
    setWorkingAddress: (state, action: PayloadAction<string>) => {
      state.workingAddress = action.payload
    },
    setOnboardingCompleted: (state, action: PayloadAction<boolean>) => {
      if (state.userDetails) {
        state.userDetails.onboardingCompleted = action.payload
      }
    },
  },
})

export const {
  setAuthenticated,
  setReady,
  setBootstrapError,
  setSessionExpired,
  setName,
  setAccessToken,
  setNovuSubscriberInfo,
  setProductLicenses,
  setUserDetails,
  setParentOrganization,
  setSites,
  setCurrentSite,
  setOrganization,
  setAddressCandidate,
  setWorkingAddress,
  setOnboardingCompleted,
} = authSlice.actions

export default authSlice.reducer
